import { Process } from "../../../../api/recipeSimulator";

export type ManageRecipeVariantModalKey =
  | "visibleModal"
  | "visibleUpdateModal"
  | "visibleRecipeUpdateModal"
  | "ingredientVisibleModal"
  | "processingStepVisibleModal"
  | "processingStepViewModal"
  | "processingStepEditModal";

export type ManageRecipeVariantState = {
  pendingDeleteVariantIds: string[];
  visibleModal: boolean;
  visibleUpdateModal: boolean;
  visibleRecipeUpdateModal: boolean;
  ingredientVisibleModal: boolean;
  processingStepVisibleModal: boolean;
  processingStepViewModal: boolean;
  processingStepEditModal: boolean;
  selectedProcess: Process | null;
  deleteIngredient: any | null;
  isOriginal: boolean;
  variants: any[];
  isNewRecipe: boolean;
  variantId: string | null;
  deleteVariant: any | null;
  scrollToBottom: boolean;
  scrollToTop: boolean;
  isAtBottom: boolean;
  tenantId: string;
  selectedVariants: any[];
};

export const initialManageRecipeVariantState: ManageRecipeVariantState = {
  pendingDeleteVariantIds: [],
  visibleModal: false,
  visibleUpdateModal: false,
  visibleRecipeUpdateModal: false,
  ingredientVisibleModal: false,
  processingStepVisibleModal: false,
  processingStepViewModal: false,
  processingStepEditModal: false,
  selectedProcess: null,
  deleteIngredient: null,
  isOriginal: false,
  variants: [],
  isNewRecipe: false,
  variantId: null,
  deleteVariant: false,
  scrollToBottom: false,
  scrollToTop: false,
  isAtBottom: false,
  tenantId: "",
  selectedVariants: []
};

export type ManageRecipeVariantAction =
  | { type: "OPEN_MODAL"; modal: ManageRecipeVariantModalKey }
  | { type: "CLOSE_MODAL"; modal: ManageRecipeVariantModalKey }
  | { type: "SET_MODAL"; modal: ManageRecipeVariantModalKey; open: boolean }
  | { type: "SET_VARIANTS"; variants: any[] }
  | { type: "SET_SELECTED_PROCESS"; process: Process | null }
  | { type: "SET_TENANT"; tenantId: string }
  | { type: "SET_VARIANT_ID"; variantId: string | null }
  | { type: "SET_DELETE_INGREDIENT"; deleteIngredient: any | null }
  | { type: "SET_DELETE_VARIANT"; deleteVariant: any | null }
  | { type: "SET_PENDING_DELETE_VARIANT_IDS"; pendingDeleteVariantIds: string[] }
  | { type: "SET_IS_ORIGINAL"; isOriginal: boolean }
  | { type: "SET_IS_NEW_RECIPE"; isNewRecipe: boolean }
  | { type: "SET_SCROLL_TO_BOTTOM"; scrollToBottom: boolean }
  | { type: "SET_SCROLL_TO_TOP"; scrollToTop: boolean }
  | { type: "SET_IS_AT_BOTTOM"; isAtBottom: boolean }
  | { type: "SET_SELECTED_VARIANTS"; selectedVariants: any[] }
  | { type: "RESET" };

export const manageRecipeVariantReducer = (
  state: ManageRecipeVariantState,
  action: ManageRecipeVariantAction
): ManageRecipeVariantState => {
  switch (action.type) {
    case "OPEN_MODAL":
      return { ...state, [action.modal]: true };
    case "CLOSE_MODAL":
      return { ...state, [action.modal]: false };
    case "SET_MODAL":
      return { ...state, [action.modal]: action.open };
    case "SET_VARIANTS":
      return { ...state, variants: action.variants };
    case "SET_SELECTED_PROCESS":
      return { ...state, selectedProcess: action.process };
    case "SET_TENANT":
      return { ...state, tenantId: action.tenantId };
    case "SET_VARIANT_ID":
      return { ...state, variantId: action.variantId };
    case "SET_DELETE_INGREDIENT":
      return { ...state, deleteIngredient: action.deleteIngredient };
    case "SET_DELETE_VARIANT":
      return { ...state, deleteVariant: action.deleteVariant };
    case "SET_PENDING_DELETE_VARIANT_IDS":
      return { ...state, pendingDeleteVariantIds: action.pendingDeleteVariantIds };
    case "SET_IS_ORIGINAL":
      return { ...state, isOriginal: action.isOriginal };
    case "SET_IS_NEW_RECIPE":
      return { ...state, isNewRecipe: action.isNewRecipe };
    case "SET_SCROLL_TO_BOTTOM":
      return { ...state, scrollToBottom: action.scrollToBottom };
    case "SET_SCROLL_TO_TOP":
      return { ...state, scrollToTop: action.scrollToTop };
    case "SET_IS_AT_BOTTOM":
      return { ...state, isAtBottom: action.isAtBottom };
    case "SET_SELECTED_VARIANTS":
      return { ...state, selectedVariants: action.selectedVariants };
    case "RESET":
      return initialManageRecipeVariantState;
    default:
      return state;
  }
};
